import Context from './Context';
import CryptoJS from 'crypto-js';

import cookies from 'js-cookie';
import { io } from 'socket.io-client';

import { useEffect, useState, useRef } from 'react';
import { requestAuth } from '../config/UserRequest';
import { ToastContainer } from 'react-toastify';
import { requestGetCart } from '../config/CartRequest';
import { requestGetConversationByUserId } from '../config/MessageRequest';

export function Provider({ children }) {
    const [dataUser, setDataUser] = useState({});
    const [cartData, setCartData] = useState([]);
    const [couponData, setCouponData] = useState([]);

    const [dataConversation, setDataConversation] = useState();
    const [newMessage, setNewMessage] = useState();
    const [socket, setSocket] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const fetchConversation = async () => {
        const res = await requestGetConversationByUserId();
        setDataConversation(res.metadata._id);
    };

    useEffect(() => {
        if (dataUser?.isAdmin === false) {
            fetchConversation();
        }
    }, [dataUser]);

    useEffect(() => {
        if (!dataUser._id) return;

        const socketInstance = io(import.meta.env.VITE_API_URL, {
            withCredentials: true,
        });

        setSocket(socketInstance);

        socketInstance.on('connect', () => {
            console.log('Socket connected:', socketInstance.id);
            socketInstance.emit('join_notifications', dataUser._id);
            socketInstance.emit('userConnected', dataUser._id);
        });

        socketInstance.on('new_message', (data) => {
            setNewMessage(data);
        });

        return () => {
            socketInstance.disconnect();
        };
    }, [dataUser._id]);

    const fetchAuth = async () => {
        try {
            const res = await requestAuth();

            // Temporary fix: Skip crypto decryption if malformed
            try {
                const bytes = CryptoJS.AES.decrypt(res.metadata, import.meta.env.VITE_SECRET_CRYPTO);
                const originalText = bytes.toString(CryptoJS.enc.Utf8);
                if (!originalText) {
                    console.error('Failed to decrypt data - clearing auth');
                    cookies.remove('logged');
                    return;
                }
                const user = JSON.parse(originalText);
                setDataUser(user);
            } catch (cryptoError) {
                console.error('Crypto error - clearing auth:', cryptoError);
                cookies.remove('logged');
                // Try direct parsing as fallback
                if (typeof res.metadata === 'object') {
                    setDataUser(res.metadata);
                }
            }
        } catch (error) {
            console.error('Auth error:', error);
            cookies.remove('logged');
        }
    };

    const fetchCart = async () => {
        try {
            const res = await requestGetCart();
            setCartData(res.metadata.items);
            setCouponData(res.metadata.coupon);
        } catch (error) {
            console.error('Error fetching cart:', error);
        }
    };

    useEffect(() => {
        const token = cookies.get('logged');

        if (!token) {
            return;
        }
        fetchAuth();
        fetchCart();
    }, []);

    return (
        <Context.Provider
            value={{
                dataUser,
                fetchAuth,
                cartData,
                fetchCart,
                couponData,
                dataConversation,
                newMessage,
                socket,
                isMobileMenuOpen,
                setIsMobileMenuOpen,
            }}
        >
            {children}
            <ToastContainer />
        </Context.Provider>
    );
}
